import React from 'react';
import dateFormat from 'dateformat';
import convertTime from 'convert-time';

/**
 * Event Details Component
 *
 * Conditions are made to show genre, subgenre, artist lineup, price range (if they are present)
 * Missing values for lineup/price range has default value of tbd
 */
const EventDetails = (props) => {
   
	// function to round price number to 2 decimal places
	const roundNumber = (x) => {
		return Number.parseFloat(x).toFixed(2);
	};

	// if subGenre is defined, and is not the same as genre
	// this is placed into below genreNames
	let subGenre;
	if(props.event.classifications[0].subGenre) {
		subGenre = (
			<span>
				{props.event.classifications[0].genre.name !== props.event.classifications[0].subGenre.name ? <span>/{props.event.classifications[0].subGenre.name}</span> : ''}
			</span>
		)
	}

	// if genres available
	let genreNames;
	if(props.event.classifications[0].genre.name !== 'Undefined') {
		genreNames =  (
			<p className="event-details__genre">
				{props.event.classifications[0].genre.name}
				{ subGenre }
			</p>
		)
	} 
	// show artist line up if available
	let lineUp;
	if(props.event._embedded.attractions) {
		lineUp = (
			<div>
				{ props.event._embedded.attractions.map((attraction, index) => {
					return (
						<p className="event-details__attraction" key={index}>{attraction.name}</p>
					)
				})}	
			</div>
		)
	} else {
		lineUp = (
			<p className="event-details__attraction">tbd</p>
		)
	}
	// show price range if available
	// if statement checks for priceRanges key, and if theres a min value
	// only show max price if not the same as min
	let priceRanges;
	if(props.event.priceRanges && props.event.priceRanges[0].min) {
		priceRanges = (
			<p className="event-details__cost">
				${roundNumber(props.event.priceRanges[0].min)}
				{props.event.priceRanges[0].min !== props.event.priceRanges[0].max ? <span>-${roundNumber(props.event.priceRanges[0].max)}</span> : '' }
			</p>	
		)
	} else {
		priceRanges = (
			<p className="event-details__cost">tbd</p>
		)
	}
	// generate google url for address link
	let directionLink;
	let address = props.event._embedded.venues[0].address.line1.split(' ').join('+');
	let postalCode = props.event._embedded.venues[0].postalCode.split(' ').join('+');
	let directionUrl = `https://www.google.ca/maps/place/${address},+Toronto,+ON+${postalCode}/`;
	directionLink =  (
		<a className="event-details__direction-link" href={directionUrl} target="_blank" rel="noopener noreferrer">Get Directions</a>
	)

	return (
		<div className="event-details" tabIndex="-1" onKeyDown={props.onKeyDown}>
			<div className="event-details__content">

				<div className="event-details__row-1">
					<div className="event-details__image-container">
						<div className="event-details__image-accent">
							<figure className="event-details__image-wrapper">
								<img className="event-details__image" src={props.imageurl} alt=""/>
							</figure>
						</div>
						<p className="event-details__date">{dateFormat(props.event.dates.start.localDate, 'mmm dd', true)}</p>
					</div>
					<div className="event-details__title-container">
						<h1 className="event-details__title">{props.event.name}</h1>
						{ genreNames }
						{/* If localTime available, show time */}
						{props.event.dates.start.localTime ? (
					       <p className="event-details__time">{convertTime(props.event.dates.start.localTime)}</p>
					      ) : null}
					</div>
				</div>

				<div className="event-details__row-2">
					<div className="event-details__venue-container">
						<p className="event-details__heading">Venue:</p>
						<p className="event-details__venue">{props.event._embedded.venues[0].name}</p>
						<p className="event-details__venue-address">{props.event._embedded.venues[0].address.line1}</p>
						{ directionLink }
					</div>
					<div className="event-details__lineup-container">
						<p className="event-details__heading">Line-Up:</p>
						{ lineUp }
					</div>
					
					<div className="event-details__cost-container">
						<p className="event-details__heading">Cost:</p>
						{ priceRanges }
					</div>

				</div>
				<a className="event-details__ticket-link" href={props.event.url} target="_blank" rel="noopener noreferrer">View Tickets</a>
				<button className="event-details__close-button" onClick={props.onClick}></button>
			</div>
		</div>
	)
}

export default EventDetails;

